<template>
    <div class="uk-padding  uk-margin-remove-top">
        <div class="uk-container">
            <div uk-grid>

                <div class="uk-width-3-5@m" style=" z-index: 0;">
                    <img src="../../assets/donorsBg.jpg"  alt="">
                </div>
                <div class="uk-width-2-5@m uk-padding test" style="margin-left: -120px; z-index: 1;">
                    <div class="" style="background-color: rgb(3, 56, 96); height: 100%;  border-radius: 5px">
                        <div class="uk-padding">
                            <h3 class=" uk-light uk-text-left uk-text-uppercase " style="margin-top: 30px; font-variant: all-small-caps; font-family: 'Nanum Gothic', sans-serif ">Our Partners</h3>
                            <hr>
                            <ul class="uk-list uk-list-bullet uk-text-left">
                                <li><router-link class="uk-light uk-text-left linkColor" to="/alumni">Alumni</router-link></li>
                                <li><router-link class="uk-light uk-text-left linkColor" to="/churchandcommunity">Church & Community Relations</router-link></li>
                                <li><router-link class="uk-light uk-text-left linkColor" to="/giving">Donors</router-link></li>
                                <li><router-link class="uk-light uk-text-left linkColor" to="/parents">Parents</router-link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <br><br>
        </div>
    </div>
</template>

<script>
    export default {
        name: "byCategories"
    }
</script>

<style scoped>
    .linkColor{
        color: white;
        font-variant: all-small-caps;
        font-size: 18px;
    }
    h3{
        color: rgba(255, 215, 3,0.9);
        font-family: soleil, sans-serif !important;
        font-style: normal;
        font-weight: 500;
    }
    @media screen and (max-width:600px){
      .test{
          margin-left: auto !important;
      }



    }
</style>
